import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ApiEmailService } from '../../../___LOGIC/__api/api-email.service';
import { GuiFlowService } from '../../../___LOGIC/__gui/gui-flow.service';
import { MatTabGroup } from '@angular/material/tabs';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';
import { EmailConfig } from '../../../___LOGIC/__interfaces/EmailConfig';
import { FunctionsService } from '../../../___LOGIC/__common/functions.service';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import { SmartSelectComponent } from '../../__common/smart-select/smart-select.component';
import { MinutaService } from 'src/app/___LOGIC/__voyjaleas/minuta.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-email-composer',
  templateUrl: './email-composer.component.html',
  styleUrls: ['./email-composer.component.css']
})
export class EmailComposerComponent implements OnInit {

  @ViewChild('tabGroup') tabGroup!: MatTabGroup;
  /* SMART SELECT */
  @ViewChild('dynamicContainer', { read: ViewContainerRef, static: true })
  dynamicContainer!: ViewContainerRef;

  emailDataToSend = {};
  emailConfig: EmailConfig = {
    includeCc: false,            // Default boolean value
    templateCategory: '',        // Default string value
    templates: null,               // Empty array
    selectedTemplate: null,        // Empty object
    emailSubject: '',
    emailHtml: null as SafeHtml  // Default value for SafeHtml
  };
  templateCategories;
  requiredFields: {
    [key: string]: {
      value: string | null;
      mandatory: boolean;
      icon: string | null;
    };
  } = {};
  formData: { [key: string]: any } = {};
  icons : { fieldName: string; icon: string; }[];

  dependencyResolved = {};
  dependencyObjects = [];
  loading = false;
  emailSent = false;

  testing = environment.testingMode;

  constructor(private emailService: ApiEmailService,private guiFLow: GuiFlowService,private sanitizer: DomSanitizer,private commonFunctions: FunctionsService,private resolver: ResolverService,private componentResolver: ComponentFactoryResolver,private minutaService: MinutaService) {
    this.emailService.requestTemplateCategories()
    .subscribe(obj => this.loadCategories(obj));
  }

  ngOnInit(): void {}

  loadCategories(data){
    if(data && data.categories){
      this.templateCategories = data.categories;
    }else{
      this.guiFLow.openSimpleSnackBar('Error getting template Categories','error');
    }
  }

  sendEmail(){
    this.loading = true;
    this.emailDataToSend = this.emailService.getEmailHtmlBodyReadyToSend();
    this.emailService.sendPhpEmail(this.emailDataToSend).subscribe(
      (response) => {
        this.loading = false;
        response && response.status == 'success'? this.emailSent = true : null;
        this.resolver.processAnswer(response,null,null,'📩');
      },
      (error) => {
        this.loading = false;
        this.resolver.processAnswer(error,null,null,null);
      }
    )
  }

  onTemplateSelection(event){
    if(event.value){
      // Get all info loaded from the BACKEND from the template selected
      this.emailConfig.selectedTemplate = event.value;
      if(this.emailConfig.selectedTemplate['dependencies']){
        this.loadTemplateDependencies(this.emailConfig.selectedTemplate['dependencies'])
      }
      this.initFormData();
    }else{
      this.guiFLow.openSimpleSnackBar('No template found in backend','error');
    }
  }

  loadTemplateConfigObjectToView(data){
    if(data){
      if (data.response && data.response.success) {
         this.emailConfig.templates = data.response[this.emailConfig.templateCategory].options;
        } else {
          alert(data.response.message);
      }
      data.response.success? this.guiFLow.openSimpleSnackBar(data.response.message,'success') : this.guiFLow.openSimpleSnackBar('Error loading email template config obj','warning');
    }else{
      this.guiFLow.openSimpleSnackBar('Error getting email config','error');
    }
  }

  loadTemplateDependencies(dependencies: any[]): void {
    this.dynamicContainer.clear();
    for (const dep of dependencies) {
      if (dep.dependsOf) {
        const tableName = dep.dependsOf.replace('FK_ID_', ''); // Remove "FK_ID_" prefix

        if (dep.dependsOfResolved) {
          // If already resolved, handle the queryId dependency
          if (dep.queryId) {
            this.resolver.getBackendDataForQueryId(dep.queryId, true, null);
          } else {
            this.guiFLow.openSimpleSnackBar('No queryId for dependency.', 'error');
          }
        } else {
          // If not resolved, dynamically load app-smart-select
          this.loadSmartSelect(tableName, dep);
        }
      }
    }
  }

  isDependsOfResolved(selectedTemplate){
    const dependencies = selectedTemplate.dependencies || [];
    for (const dep of dependencies) {
        if ((dep.dependsOf &&  !dep.dependsOfResolved )|| this.resolver.isLoading(dep.dependsOf.replace('FK_ID_', ''))) {
            return false; // A query is still loading
        }
    }
    return true; // All queries have finished loading
  }

  isQueryResolved(selectedTemplate: any): boolean {
    // Check if all dependencies in the selected template are resolved
    const dependencies = selectedTemplate.dependencies || [];
    for (const dep of dependencies) {
        if (dep.dependsOf && dep.queryId && this.resolver.isLoading(dep.queryId)) {
            return false; // A query is still loading
        }
    }
    return true; // All queries have finished loading
  }

  loadSmartSelect(tableName: string, dep: any): void {
      // Clear the dynamic container before adding a new component
      this.dynamicContainer.clear();
    
      // Create a factory for SmartSelectComponent
      const factory = this.componentResolver.resolveComponentFactory(SmartSelectComponent);
    
      // Create the component instance
      const componentRef = this.dynamicContainer.createComponent(factory);
    
      // Pass the tableName to the smart select component
      componentRef.instance.tableName = tableName;
    
      // Listen for the 'selectedObj' event
      componentRef.instance.selectedObj.subscribe(async (selection: any) => {
        dep.dependsOfResolved = true; // Mark as resolved
        dep.dependsOfValue = selection.id;
        this.handleSelectedId(selection);
    
        // Check if the queryId exists
        if (dep.queryId) {
          try {
            // Await the Promise returned by toPromise()
            const result = await this.resolver.getBackendDataForQueryIdAndReturn(dep.queryId, true, selection.id).toPromise();
            this.resolver.saveDataToLocalCache(dep.queryId,result.data[0]);
            // Save the resolved data to the dependency
            this.dependencyObjects.push(result.data[0]);
            dep.queryIdData = result;
            /// TO DO
            this.dependencyResolved[dep.id] = result.data[0];
            this.buildFormData(this.emailConfig.selectedTemplate['templateId']);
            /* this.emailService.setConfigValue(dep.queryId,data.records[0]); */
    
            // Optionally, take additional actions after the data is resolved
            console.log(`Data resolved for queryId ${dep.queryId}:`, result.data);
          } catch (error) {
            console.error(`Failed to resolve queryId ${dep.queryId}:`, error);
            this.guiFLow.openSimpleSnackBar(`Failed to resolve queryId: ${dep.queryId}`, 'error');
          }
        } else {
          // Notify if no queryId is available
          this.guiFLow.openSimpleSnackBar('No queryId for dependency.', 'error');
        }
      });
  }

  buildFormData(templateId){
    debugger
    switch(templateId){
      case 'minuta':
        this.formData['name'] = this.dependencyResolved['clientDetails']['name'];
        this.formData['present'] = this.minutaService.generatePresentText(this.dependencyResolved['clientDetails']);
        this.formData['goal'] = this.minutaService.generateGoalText(this.dependencyResolved['clientDetails']);
        this.formData['future'] = this.minutaService.generateFutureText(this.dependencyResolved['clientDetails']);
        this.formData['comments'] = this.dependencyResolved['clientDetails']['comments'];
        break;
      case 'minutaReceived':
        this.formData['name'] = '';
        break;
      case 'sendCotizacion':
        this.formData['link'] = '';
        this.formData['emailTo'] = this.dependencyResolved['clientDetails']['email'];
        this.formData['name'] = this.dependencyResolved['clientDetails']['name'];
        this.formData['code'] = '';
        break;
      case 'videocall30min':
        this.formData['templateId'] = templateId;
        break;
      default:
        debugger
        break;
    }
  }

  handleSelectedId(selectedId: any): void {
    // Perform actions with the selected ID
    console.log('Dependency resolved with ID:', selectedId);
  }

  onSelectCategory(cat){
    if(cat.value){
      this.emailConfig.selectedTemplate = null;
      this.emailConfig.templateCategory = cat.value;
      // GET category email templates
      this.emailService.cleanCache('getEmailTemplateConfig');
      this.emailService.loadTemplateConfigObject(this.emailConfig.templateCategory)
      .subscribe(obj => this.loadTemplateConfigObjectToView(obj));
    }else{
      this.guiFLow.openSimpleSnackBar('Error getting template config','error');
    }
  }

  loadTemplateToPreview(){
    if(this.emailConfig.selectedTemplate && this.emailConfig.selectedTemplate['templateId']){
      this.emailService.getEmailPreview(this.emailConfig.selectedTemplate['templateId'],this.formData)
      .subscribe(obj => this.processLoadTemplate(obj));
    }else{
      this.guiFLow.openSimpleSnackBar('No selected template','error');
    }
  }

  processLoadTemplate(res){
    if(res){
      if (res.htmlBody) {
          // Replace placeholders and sanitize HTML
            this.emailConfig.emailHtml = this.sanitizer.bypassSecurityTrustHtml(res.htmlBody);
            this.emailConfig.emailSubject = res.postedData.subject;
            // EMAIL CONFIG
        } else {
          this.guiFLow.openSimpleSnackBar('Failed to load HTML BODY.','error');
      }
    }else{
      this.guiFLow.openSimpleSnackBar('Error generating HTML BODY','error');
    }
  }

  showHidePreviewEmail(){
    this.emailService.requestPreview();
    this.icons = this.parseRequiredFields(this.emailConfig.selectedTemplate['requiredFields']);
    this.icons.push( {fieldName: 'subject', icon: 'fas fa-pen'})
    this.loadTemplateToPreview();
    this.selectTab(1);
  }

  // El boton lo enseño si ya todo se ha seleccionado y los campos no son null
  showPreviewButton(){
    return this.emailConfig.templates && this.isTemplateSelected() && this.areAllFieldsNotNull(this.formData);
  }

  // Espera a que el usuario haga click y se cumpla
  showEmailPreviewSection(){
    if(this.emailService.isRequestedPreview() && this.isTemplateSelected()){
      return true;
    }else{
      return false;
    }
  }

  areAllFieldsNotNull(obj) {
    return this.commonFunctions.areAllFieldsNotNull(obj);
  }

  updateField(key: string, value: any): void {
    if (this.formData.hasOwnProperty(key)) {
      this.formData[key] = value;
    }
  }

  selectTab(index: number): void {
    this.tabGroup.selectedIndex = index;
  }

  // Company CC Emails from DB
  includeCCs(){
    this.emailConfig.includeCc = !this.emailConfig.includeCc;
  }
  
  getRequiredFields(selectedTemplate): {
    [key: string]: {
      value: string | null;
      mandatory: boolean;
      icon: string | null;
    };
  } {
    return selectedTemplate.requiredFields || {};
  }

  isTemplateSelected(){
    return this.emailConfig && this.emailConfig.selectedTemplate && this.emailConfig.selectedTemplate['templateId'];
  }

  initFormData(){  
    // Initialize formData with the same structure as requiredFields
    for (const key in this.emailConfig.selectedTemplate['requiredFields']) {
      if (this.emailConfig.selectedTemplate['requiredFields'].hasOwnProperty(key)) {
        this.formData[key] = this.emailConfig.selectedTemplate['requiredFields'][key]['value'];
      }
    }
    // INIT FIELDS
    this.formData['subject'] = this.emailConfig.selectedTemplate['subject'] || '';
    this.testing? this.formData['emailTo'] = this.emailService.getTestingEmail() : null;
    this.testing? this.formData['name'] = this.emailService.getTestingName() : null;
    this.emailService.setConfigValue('subject',this.emailConfig.selectedTemplate['subject']);
    this.testing? this.emailService.setConfigValue('emailTo',this.emailService.getTestingEmail()) : this.emailService.setConfigValue('emailTo',this.formData['emailTo']);
  }

  getIconClass(field){
    return this.getIconByFieldName(this.icons,field);
  }

  getIconByFieldName(
    array: { fieldName: string; icon: string | null }[],
    fieldName: string
  ): string | null {
    const field = array.find(item => item.fieldName === fieldName);
    return field ? field.icon : null;
  }

  parseRequiredFields(
    requiredFields: {
      [key: string]: {
        value: string | null;
        mandatory: boolean;
        icon: string | null;
      };
    }
  ): { fieldName: string; icon: string | null }[] {
    return Object.entries(requiredFields)
      .filter(([_, value]) => value.icon !== null) // Exclude objects with null icons
      .map(([key, value]) => ({
        fieldName: key,
        icon: value.icon
      }));
  }

  goBack() {
    window.history.back();
  }

  clearData(){
    debugger
  }


  /* copyEmail(){
    this.regenerate();
    this.emailApi.emailSender('sendMinuta','minuta1',this.getClientDataObj()['email'],this.data).subscribe(
      (response) => {
        this.resolver.processAnswer(response,null,null,'📩');
      },
      (error) => {
        this.resolver.processAnswer(error,null,null,null);
      }
    );
  } */

}
